/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {MonkeysGoldServerDataParser} from "../MonkeysGoldServerDataParser";
import {IMonkeysGoldInitData} from "./IMonkeysGoldServerData";
import {AvalancheParsedInitData} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheParsedServerData";
import {IExistingBigSymbols} from "./IExistingBigSymbols";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class MonkeysGoldParsedInitData extends AvalancheParsedInitData {
    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    public get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }

    private readonly _numberFilledRows:number;
    private readonly _fsMultiplier:number;
    private readonly _existingBigSymbols:IExistingBigSymbols[];
    private readonly _fsMultiplierIncrease:number;
    private readonly _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];
    private readonly _accumulatedRoundWin:string;

    constructor(rawData:IMonkeysGoldInitData, dataParser:MonkeysGoldServerDataParser) {
        dataParser.parseInitReelsAfterColapse(rawData);
        rawData.reels = dataParser.parseInitReelsRestoreIntoFS(rawData);
        super(rawData, dataParser);
        this._numberFilledRows = rawData.numberFilledRows;
        this._fsMultiplier = rawData.fsMultiplier;
        this._existingBigSymbols = rawData.existingBigSymbols;
        this._fsMultiplierIncrease = rawData.fsMultiplierIncrease;
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    get fsMultiplierIncrease():number {
        return this._fsMultiplierIncrease;
    }

    get existingBigSymbols():IExistingBigSymbols[] {
        return this._existingBigSymbols;
    }

    get fsMultiplier():number {
        return this._fsMultiplier;
    }

    get numberFilledRows():number {
        return this._numberFilledRows;
    }
}